/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ChannelIconSVG } from 'cx-ui-components';
import { camelCaseToRegularForm } from 'serenova-js-utils/strings';
import CheckboxFilterMenu from '../../../containers/CheckboxFilterMenu';
import { generateUUID } from 'serenova-js-utils/uuid';


const StyledChannelWrapper = styled.div`
  display: inline-block;
  cursor: auto;
  &:not(:last-child) {
    margin-right: 6px;
  }
`;

const FilterMenu = styled(CheckboxFilterMenu)`
  & .DropDown-SubMenu {
    width: 200px;
  }
`;

export const helperFunctions = {
  channelTypesFilter1: (onChange, tableType, allActive) => channelTypesFilter1(onChange, tableType, allActive),
  filterMethod: ({ value = 'All' }, { agentName, wrapTypes }, filterValues, allActive) =>
    value === 'All'
      ? allActive
      : Object.keys(wrapTypes)
          .reduce(
            (prev, curr) =>
              wrapTypes[curr].display
                ? [...prev, curr === 'sms' ? curr.toUpperCase() : camelCaseToRegularForm(curr)]
                : prev,
            []
          )
          .filter(value => filterValues.map(({ name }) => name).includes(value)).length > 0
};

export default function wrapUpTypesColumn(wrapTypes, tableType, filterValues, allActive) {
  const wrapUpTypesColumn = {
    Header: 'Wrap-Up State',
    show: wrapTypes,
    id: 'wrapTypes',
    width: 185,
    resizable: false,
    sortable: false,
    accessor: 'wrapTypes',
    filterMethod: (filter, row) => helperFunctions.filterMethod(filter, row, filterValues, allActive),
    Filter: ({ onChange }) => helperFunctions.channelTypesFilter1(onChange, tableType, allActive),
    Cell: ({ value }) => (
      <div style={{ textAlign: 'center' }}>
        {Object.keys(value).reduce(
          (acc, item, index) =>
            value[item].display
              ? (function() {
                
               return [
                  ...acc,
                  <StyledChannelWrapper key={generateUUID()}>
                    <ChannelIconSVG
                      channelIconType={value[item].active ? 'in-focus' : 'secondary'}
                      channelType={item}
                      size={25}
                      animated
                    />
                  <div>{ value[item].count!==0? value[item].count:0}</div>
                  </StyledChannelWrapper>
                ]})()
              : acc,
          []
        )}
      </div>
    )
  };

  wrapUpTypesColumn.Cell.propTypes = { value: PropTypes.any };

  return wrapUpTypesColumn;
}

export function channelTypesFilter1(onChange, tableType, allActive) {
  return (
    <FilterMenu
      menuType="WrapType"
      tableType={tableType}
      buttonType="columnFilter"
      selectionType="checkbox"
      updateFilter={onChange}
      hasActiveFilter={!allActive}
    >
      Wrap-Up State
    </FilterMenu>
  );
}
